// Translation: Account > Members > Members list > Invitation dialog (English)
export default Object.freeze({
	actions: {
		cancel: 'Cancel',
		invite: 'Invite'
	},
	fields: {
		email: {
			label: 'Email address',
			placeholder: 'Enter email address'
		},
		role: {
			label: 'Role'
		}
	},
	title: 'Invite team member'
})
